<template>
  <div class="date-picker-calendar">
    <div class="calendar-header">
      <bp-select size="sm" :options="months" v-model="month" />
      <bp-select size="sm" :options="years" v-model="year" />

      <div />
      <bp-button
        size="sm"
        color="neutral"
        variant="filled-1"
        icon="fa-regular fa-angle-left"
        @click="subtractMonth"
      />
      <bp-button
        size="sm"
        color="neutral"
        variant="filled-1"
        icon="fa-regular fa-angle-right"
        @click="addMonth"
      />
    </div>

    <div class="d-flex gap-5 mt-5">
      <bp-button
        v-for="_mode in ['single', 'range']"
        block
        size="sm"
        :key="_mode"
        :color="mode == _mode ? 'primary' : 'neutral'"
        :variant="mode == _mode ? 'filled-2' : 'outlined'"
        @click="changeMode(_mode)"
      >
        {{ _mode == "single" ? "Dia" : "Período" }}
      </bp-button>
    </div>

    <table class="w-100 mt-6">
      <thead>
        <th
          class="pb-5"
          v-for="(weekDay, i) in ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']"
          :class="i === 0 || i === 6 ? 'text-neutral-076' : 'text-neutral-400'"
          :key="i"
        >
          {{ weekDay }}
        </th>
      </thead>
      <tbody>
        <tr v-for="(week, i) in calendar" :key="i">
          <td
            v-for="(day, j) in week"
            :key="j"
            :class="getCellClass(day)"
            @mouseover="onHover(day)"
            @mouseleave="hoveredDate = ''"
          >
            <button class="functional-1" @click="selectDay(day)">
              {{ day.day }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex gap-5 mt-6">
      <bp-button
        block
        size="md"
        label="Limpar"
        @click="clear"
        color="neutral"
        variant="outlined"
      />
      <bp-button
        block
        size="md"
        label="Aplicar"
        :disabled="!start || !end"
        @click="apply"
      />
    </div>
  </div>
</template>
<script>
import { getArrayOfDaysInMonth, getYearRange } from "@/functions/helpers";
import moment from "moment";
const months = [
  { id: 1, name: "Janeiro" },
  { id: 2, name: "Fevereiro" },
  { id: 3, name: "Março" },
  { id: 4, name: "Abril" },
  { id: 5, name: "Maio" },
  { id: 6, name: "Junho" },
  { id: 7, name: "Julho" },
  { id: 8, name: "Agosto" },
  { id: 9, name: "Setembro" },
  { id: 10, name: "Outubro" },
  { id: 11, name: "Novembro" },
  { id: 12, name: "Dezembro" }
];
export default {
  props: {
    value: {
      type: Array,
      default: () => ["", ""]
    }
  },
  data() {
    const year = new Date().getFullYear();
    const years = [...getYearRange(year + 10, year - 10, -1)]
      .sort()
      .map(y => ({ id: y, name: y }));

    const mode =
      !!this.value[0] &&
      !!this.value[1] &&
      moment(this.value[0]).isSame(this.value[1], "day")
        ? "single"
        : "range";
    return {
      months,
      years,
      month: 1,
      year: 2024,

      start: "",
      end: "",
      hoveredDate: "",

      mode: "range"
    };
  },
  computed: {
    calendar() {
      let week = 0;
      let day = 0;
      return [...getArrayOfDaysInMonth(this.year, this.month)].reduce(
        (acc, cur) => {
          if (day === 7) {
            week++;
            day = 0;
            acc.push([]);
          }
          acc[week].push(cur);
          day++;
          return acc;
        },
        [[]]
      );
    }
  },
  methods: {
    prepareDate(day) {
      let [month, year] = [this.month, this.year];
      if (!day.isCurrentMonth) {
        if (day.day > 15) {
          month--;
        } else {
          month++;
        }
      }
      return moment(`${year}-${month}-${day.day}`, "YYYY-MM-DD");
    },

    subtractMonth() {
      this.month = this.month === 1 ? 12 : this.month - 1;
      if (this.month === 12) {
        this.year--;
      }
    },
    addMonth() {
      this.month = this.month === 12 ? 1 : this.month + 1;
      if (this.month === 1) {
        this.year++;
      }
    },
    setStartAndEnd() {
      if (!this.value[0] || !this.value[1]) {
        this.month = moment().month() + 1;
        this.year = moment().year();
        return;
      }

      this.start = moment(this.value[0]).format("YYYY-MM-DD");
      this.end = moment(this.value[1]).format("YYYY-MM-DD");

      this.month = moment(this.value[1]).month() + 1;
      this.year = moment(this.value[1]).year();
    },
    setInitialMode() {
      this.mode =
        !!this.value[0] &&
        !!this.value[1] &&
        moment(this.value[0]).isSame(this.value[1], "day")
          ? "single"
          : "range";
    },
    changeMode(mode) {
      this.mode = mode;
      this.start = "";
      this.end = "";
    },
    selectDay(day) {
      const date = this.prepareDate(day);

      if (this.mode == "single") {
        this.start = date;
        this.end = date;
        return;
      }

      if (this.start && this.end) {
        this.start = date;
        this.end = "";
        return;
      }
      if (!this.start || date.isBefore(this.start)) {
        this.start = date;
      } else {
        this.end = date;
      }
    },
    clear() {
      this.start = "";
      this.end = "";
      this.apply();
    },
    apply() {
      this.$emit("input", [this.start, this.end]);
    },

    onHover(day) {
      if (this.start && !this.end) {
        const date = this.prepareDate(day);
        if (date.isAfter(this.start)) this.hoveredDate = date;
      }
    },

    isPast(day) {
      const date = this.prepareDate(day);
      return (!day.isCurrentMonth && day.day < 15) || date.isBefore(this.start);
    },
    isBetween(day) {
      const date = this.prepareDate(day);
      const end = this.end || this.hoveredDate;
      if (!this.start || !end) return false;
      return date.isSameOrAfter(this.start) && date.isSameOrBefore(end);
    },
    isSelected(day) {
      const date = this.prepareDate(day);
      return date.isSame(this.start) || date.isSame(this.end);
    },
    getCellClass(day) {
      return {
        past: this.isPast(day),
        between: this.isBetween(day),
        selected: this.isSelected(day)
      };
    }
  },
  mounted() {
    this.setStartAndEnd();
    this.setInitialMode();
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.setStartAndEnd();
        this.setInitialMode();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.date-picker-calendar {
  padding: 20px 24px;

  .calendar-header {
    display: grid;
    grid-template-columns: auto auto 1fr auto auto;
    gap: 8px;
    ::v-deep {
      .bp-select {
        &:first-child {
          .bp-select__inner {
            width: 90px;
          }
        }
        &:nth-child(2) {
          .bp-select__inner {
            width: 60px;
          }
        }

        .bp-select__container {
          border-color: transparent !important;
        }
      }
    }
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    th,
    td {
      height: 32px;
      text-align: center;
      font-weight: normal;
    }
    td:first-child,
    td:last-child {
      button {
        color: $neutral-100;
      }
    }
    td {
      button {
        width: 100%;
        height: 32px;
        color: $neutral-700;
        box-sizing: border-box;
        background-color: unset;
        border: 1px solid transparent;
        border-radius: 2px;
        transition: 0.2s all;
      }

      &:hover button {
        background-color: $neutral-048;
        color: $neutral-1000;
      }
      button:active {
        background-color: $primary-024;
        border-color: $primary-500;
        color: $primary-600;
      }
    }
    td.past {
      button {
        color: $neutral-300;
      }
    }
    td.between {
      background-color: $neutral-048;
      button {
        color: $primary-600;
      }
    }
    td.selected {
      button {
        background-color: $primary-600;
        border-color: $primary-500;
        color: white;
      }
    }
  }
}
</style>
